import { get, post, fetchget } from "../request.js";
import { Howl } from "howler";
import { useUserInfoStore } from "../../store/modules/userInfo";
import { useGlobalStore } from "@/store/modules/global";
export const ApiGetChallengeList = {
  get: () => {
    const userInfo = useUserInfoStore();
    return get(`/challenge/list?ins=${userInfo.ins}`);
  },
};

export const ApiGetCompletedChallenge = {
  get: () => {
    return get(`/challenge/list?complete=true`);
  },
};

export const ApiGetChallengeDetail = {
  get: (tid) => {
    return get(`/challenge/detail/${tid}`);
  },
};

export const ApiGetVoiceAnalysis = {
  get: (tid) => {
    return get(`/challenge/speaking/analysis/${tid}`);
  },
};

export const ApiUploadChallengeVoice = {
  post: (tid, obj) => {
    return post(`/challenge/speaking/upload/${tid}`, obj);
  },
};

export const ApiGetWordDict = {
  get: (word) => {
    return get(`/challenge/worddict/${word}`);
  },
};

export const Apiv2GetWordDict = {
  get: (word, lang) => {
    return get(`/utility/worddict/${word}?lang=${lang}`);
  },
};

export const ApiGetWordSound = {
  get: (word) => {
    const global = useGlobalStore();
    if (!global.hideLoading) {
      // console.log("set loading");
      global.$patch((state) => {
        state.APIisLoading = true;
      });
    }

    // return fetchget(`/challenge/speaking/record/${tid}`);
    let voice = new Audio(
      import.meta.env.VITE_DOMAIN + `/utility/wordsound/${word}`
    );
    // 监听音频加载完成的事件
    voice.addEventListener("loadedmetadata", () => {
      // 音频加载完成后执行的逻辑
      console.log("音频加载完成");

      // 在这里可以隐藏 loading
      if (!global.hideLoading) {
        global.$patch((state) => {
          state.APIisLoading = false;
          state.changeIconColor = word;
        });
      }
      voice.play();
    });
    // 监听音频播放完成的事件
    voice.addEventListener("ended", () => {
      // 音频播放完成后执行的逻辑
      global.$patch((state) => {
        state.changeIconColor = false;
      });
      console.log("音频播放完成");
    });
  },
};
export const ApiGetUserRecord = {
  get: (tid) => {
    return fetchget(`/challenge/speaking/record/${tid}`);
  },
  // get: (tid) => {
  //   let voice = new Audio(
  //     import.meta.env.VITE_DOMAIN + `/challenge/speaking/record/${tid}`
  //   );
  //   voice.play();
  //   // return get(`/challenge/speaking/record/${tid}`);
  // },
};
export const ApiGetVoiceSample = {
  get: (tid, obj) => {
    return fetchget(`/challenge/speaking/sample/${tid}`, obj);
  },
};
export const ApiGetUserWord = {
  get: (tid) => {
    return fetchget(`/challenge/speaking/record/${tid}`);
    // console.log(tid, voicestart, voiceend);
    // if (sentenceSound != null) {
    //   sentenceSound.stop();
    //   sentenceSound.unload();
    //   sentenceSound = null;
    // }
    // let voice = new Audio(
    //   import.meta.env.VITE_DOMAIN + `/challenge/speaking/record/${tid}`
    // );
    // voice.currentTime = voicestart;
    // let timezone = (voiceend - voicestart) * 10;
    // voice.play();
    // setTimeout(() => {
    //   voice.pause();
    // }, timezone + 120);
  },
};
